<div class="splash-container">
  <div class="splash-content">
    <h2 class="title">Please be patient.</h2>
    <p class="subtitle">
      We’re running a few checks in the background. We’ll make it quick!
    </p>

    <div class="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <img
      src="assets/splashscreen.svg"
      alt="Namaste Hands"
      class="namaste-img"
    />
  </div>
</div>